export default __webpack_public_path__ + "static/media/generalViewSingleWithSecondaryDrain.3bf606cb.png";